import loadable from 'utils/loadable';

export default loadable(() => import('./authenticated-app'));
